import ObtainGraphApiKey from "../../../../src/content/shared/obtain-graph-api-key.mdx";
import ObtainPersonalApiKey from "../../../../src/content/shared/obtain-personal-api-key.mdx";
import * as React from 'react';
export default {
  ObtainGraphApiKey,
  ObtainPersonalApiKey,
  React
};